module.exports = __webpack_public_path__ + "static/media/yellow-bus.20025de0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/yellow-bus.png
// module id = 915
// module chunks = 0